<template>
  <footer>
    <div class="footer overlayed">
      <img src="@/assets/images/footer_desktop.png" alt="">
      <a target="_blank" href="https://mncgroup.com/">
        <img class="footer__logo" src="@/assets/images/logo_MNC_group_original-01.png" alt="">
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'footerPage',
}
</script>